export const COMPANY_BASE = 'company/COMPANY_BASE';
export const LIBRARY_LOADING = 'company/LIBRARY_LOADING';
export const LIBRARY_LOADED = 'company/LIBRARY_LOADED';

export const USERS_LOADING = 'company/USERS_LOADING';
export const USERS_LOADING_ERROR = 'company/USERS_LOADING_ERROR';
export const USERS_LOADED = 'company/USERS_LOADED';
export const COHORTS_LOADING = 'company/COHORTS_LOADING';
export const COHORTS_LOADED = 'company/COHORTS_LOADED';
export const COHORTS_LOADING_ERROR = 'company/COHORTS_LOADING_ERROR';

export const CREATING_COHORT = 'company/CREATING_COHORT';
export const COHORT_CREATED = 'company/COHORT_CREATED';
export const COHORT_UPDATING = 'company/COHORT_UPDATING';
export const COHORT_UPDATED = 'company/COHORT_UPDATED';
export const SET_COHORT_FORM = 'company/SET_COHORT_FORM';

export const TRAINERS_LOADING = 'company/TRAINERS_LOADING';
export const TRAINERS_LOADED = 'company/WELLNESS_PROGRAMS_LOADING';

export const WELLNESS_PROGRAMS_LOADING = 'company/WELLNESS_PROGRAMS_LOADING';
export const WELLNESS_PROGRAMS_LOADED = 'company/WELLNESS_PROGRAMS_LOADED';

export const COHORT_MEMBER_LOADING = 'company/COHORT_MEMBER_LOADING';
export const COHORT_MEMBER_LOADED = 'company/COHORT_MEMBER_LOADED';
